import { Component, Inject, OnInit } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Keys, StorageService } from "../../../../../../service/storage.service";
import { LenderBasicInfo } from "../../../../../../model/lender.model";
import { ConfigService } from "../../../../../../service/config.service";
import { AddFundPopupComponent } from "../../../add-fund-popup/add-fund-popup.component";
import { Router } from "@angular/router";

@Component({
    selector: 'app-allocation-error-popup',
    templateUrl: './allocation-error-popup.component.html',
    styleUrls: ['./allocation-error-popup.component.scss']
})
export class AllocationErrorPopupComponent implements OnInit {
    private matDialogRef: MatDialogRef<AllocationErrorPopupComponent>;
    private readonly matDialog: MatDialog;
    private readonly router: Router;
    private readonly storageService: StorageService;
    private readonly configService: ConfigService;
    public data;
    constructor(
        configService: ConfigService,
        storageService: StorageService,
        router: Router,
        matDialog: MatDialog,
        matDialogRef: MatDialogRef<AllocationErrorPopupComponent>,
        @Inject(MAT_DIALOG_DATA) data: {
            differenceAmount: number,
            headingText: string,
            bodyText: string, 
            buttonName: string[],
            lenderBasicInfo: LenderBasicInfo,
            sendDataToWallet: boolean;
        }
    ) {
        this.configService = configService;
        this.storageService = storageService;
        this.router = router;
        this.matDialog = matDialog;
        this.matDialogRef = matDialogRef;
        this.data = data;
    }
    ngOnInit(): void {
        
    }
    onChangeAllocation() {
        this.matDialogRef.close();
    }
    onAddMoney() {
        this.storageService.saveItem(Keys.PARENT_WALLET_PATH, this.router.url);
        const initialFundAllocationMinAmt = this.configService.getInitialFundAllocationMinAmount();
        const postFundAllocationMinAmount = this.configService.getFundAllocationMinAmount();
        const fundAllocationMinAmount = this.data.lenderBasicInfo.portfolioPresent ? postFundAllocationMinAmount : initialFundAllocationMinAmt;
        const matDialogConfig: MatDialogConfig = {
            height: '90%',
            width: '80%',
            panelClass: "dialog-responsive",
            data: (this.data.sendDataToWallet) ? { 
                virtualAccountNumber: this.data.lenderBasicInfo?.virtualAccountNumber, 
                fundAllocationMinimumAmount: fundAllocationMinAmount,
                amount: this.data.differenceAmount,
            } : {
                virtualAccountNumber: this.data.lenderBasicInfo?.virtualAccountNumber, 
                fundAllocationMinimumAmount: fundAllocationMinAmount,
            }
        };
        this.matDialog.open(AddFundPopupComponent, matDialogConfig);
        this.matDialogRef.close();
    }
}